export const languages = [
  {
    code: "en",
    name: "English",
    flagUrl: "https://www.worldometers.info//img/flags/small/tn_uk-flag.gif",
  },
  {
    code: "cs",
    name: "Czech",
    flagUrl: "https://www.worldometers.info//img/flags/small/tn_ez-flag.gif",
  },
  {
    code: "nl",
    name: "Dutch",
    flagUrl: "https://www.worldometers.info//img/flags/small/tn_nl-flag.gif",
  },
  {
    code: "de",
    name: "German",
    flagUrl: "https://www.worldometers.info//img/flags/small/tn_gm-flag.gif",
  },
  {
    code: "es",
    name: "Spanish",
    flagUrl: "https://www.worldometers.info//img/flags/small/tn_sp-flag.gif",
  },
  {
    code: "fr",
    name: "French",
    flagUrl: "https://www.worldometers.info//img/flags/small/tn_fr-flag.gif",
  },
  {
    code: "ta",
    name: "Tamil",
    flagUrl: "https://www.worldometers.info//img/flags/small/tn_in-flag.gif",
  },
  {
    code: "hi",
    name: "Hindi",
    flagUrl: "https://www.worldometers.info//img/flags/small/tn_in-flag.gif",
  },
  {
    code: "it",
    name: "Italian",
    flagUrl: "https://www.worldometers.info//img/flags/small/tn_it-flag.gif",
  },
  {
    code: "pl",
    name: "Polish",
    flagUrl: "https://www.worldometers.info//img/flags/small/tn_pl-flag.gif",
  },
  {
    code: "ru",
    name: "Russian",
    flagUrl: "https://www.worldometers.info//img/flags/small/tn_rs-flag.gif",
  },
  {
    code: "sv",
    name: "Swedish",
    flagUrl: "https://www.worldometers.info//img/flags/small/tn_sw-flag.gif",
  },
  {
    code: "zh",
    name: "Chinese",
    flagUrl: "https://www.worldometers.info//img/flags/small/tn_ch-flag.gif",
  },
  {
    code: "da",
    name: "Danish",
    flagUrl: "https://www.worldometers.info//img/flags/small/tn_da-flag.gif",
  },
  {
    code: "gk",
    name: "Greek",
    flagUrl: "https://www.worldometers.info//img/flags/small/tn_gr-flag.gif",
  },
];

export const languageFlags = {
  en: {
    id: "en",
    name: "English",
    translatedName: "English",
    flagUrl: "https://www.worldometers.info//img/flags/small/tn_uk-flag.gif",
  },
  cs: {
    id: "cs",
    name: "Czech",
    translatedName: "Čeština",
    flagUrl: "https://www.worldometers.info//img/flags/small/tn_ez-flag.gif",
  },
  nl: {
    id: "nl",
    name: "Dutch",
    translatedName: "Nederlands",
    flagUrl: "https://www.worldometers.info//img/flags/small/tn_nl-flag.gif",
  },
  de: {
    id: "de",
    name: "German",
    translatedName: "Deutsch",
    flagUrl: "https://www.worldometers.info//img/flags/small/tn_gm-flag.gif",
  },
  es: {
    id: "es",
    name: "Spanish",
    translatedName: "Español",
    flagUrl: "https://www.worldometers.info//img/flags/small/tn_sp-flag.gif",
  },
  fr: {
    id: "fr",
    name: "French",
    translatedName: "Français",
    flagUrl: "https://www.worldometers.info//img/flags/small/tn_fr-flag.gif",
  },
  ta: {
    id: "ta",
    name: "Tamil",
    translatedName: "தமிழ்",
    flagUrl: "https://www.worldometers.info//img/flags/small/tn_in-flag.gif",
  },
  hi: {
    id: "hi",
    name: "Hindi",
    translatedName: "हिन्दी",
    flagUrl: "https://www.worldometers.info//img/flags/small/tn_in-flag.gif",
  },
  it: {
    id: "it",
    name: "Italian",
    translatedName: "Italiano",
    flagUrl: "https://www.worldometers.info//img/flags/small/tn_it-flag.gif",
  },
  pl: {
    id: "pl",
    name: "Polish",
    translatedName: "Polski",
    flagUrl: "https://www.worldometers.info//img/flags/small/tn_pl-flag.gif",
  },
  ru: {
    id: "ru",
    name: "Russian",
    translatedName: "Русский",
    flagUrl: "https://www.worldometers.info//img/flags/small/tn_rs-flag.gif",
  },
  sv: {
    id: "sv",
    name: "Swedish",
    translatedName: "Svenska",
    flagUrl: "https://www.worldometers.info//img/flags/small/tn_sw-flag.gif",
  },
  zh: {
    id: "zh",
    name: "Chinese",
    translatedName: "中文",
    flagUrl: "https://www.worldometers.info//img/flags/small/tn_ch-flag.gif",
  },
  da: {
    id: "da",
    name: "Danish",
    translatedName: "Dansk",
    flagUrl: "https://www.worldometers.info//img/flags/small/tn_da-flag.gif",
  },
  el: {
    id: "el",
    name: "Greek",
    translatedName: "Ελληνικά",
    flagUrl: "https://www.worldometers.info//img/flags/small/tn_gr-flag.gif",
  },
};
